import React from "react";
var __jsx = React.createElement;
import stl from "./ScheduleLandingComponent.module.css";
import Loader from "@componentsShared/Loader/Loader";
import { useState, useEffect } from "react";
import { appointmentView } from "@/apis/scheduleApis/appointmentView";
var DeleteConfirmation = function DeleteConfirmation(_ref) {
  var t = _ref.t,
    request_id = _ref.request_id,
    closePopup = _ref.closePopup,
    onCancelRequest = _ref.onCancelRequest;
  var _useState = useState(false),
    Data = _useState[0],
    setData = _useState[1];
  useEffect(function () {
    if (request_id) {
      appointmentView(request_id).then(function (res) {
        setData(res);
      })["catch"](function (error) {
        console.log("appointmentView error", error);
      });
    }
  }, [request_id]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.DConfirmContainer
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.attentionIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("want_cancel_car_selling_request", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("p", null, !Data && /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true,
    className: stl.Ploader
  }), (Data === null || Data === void 0 ? void 0 : Data.fees_amount) === 0 && t("cancel_need_submit_new_request", {
    ns: "web_Schedule"
  }), (Data === null || Data === void 0 ? void 0 : Data.is_refundable) === 0 && (Data === null || Data === void 0 ? void 0 : Data.fees_amount) !== 0 && t("رسوم الفحص (" + (Data === null || Data === void 0 ? void 0 : Data.fees_amount) + " ريال) غير مستردة بعد الإلغاء.", {
    ns: "web_Schedule"
  }), (Data === null || Data === void 0 ? void 0 : Data.is_refundable) === 1 && (Data === null || Data === void 0 ? void 0 : Data.fees_amount) !== 0 && t("سنقوم بإعادة رسوم الفحص الفني (" + (Data === null || Data === void 0 ? void 0 : Data.fees_amount) + " ريال) إلى بطاقتك .", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, "blueBtn"].join(" "),
    onClick: function onClick() {
      return closePopup();
    }
  }, t("next", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, "redBtn"].join(" "),
    onClick: function onClick() {
      return onCancelRequest();
    }
  }, t("cancel_request", {
    ns: "web_Schedule"
  }))));
};
export default DeleteConfirmation;